import { render, staticRenderFns } from "./SummaryCards.vue?vue&type=template&id=0b8d6eb2&scoped=true&"
import script from "./SummaryCards.vue?vue&type=script&lang=js&"
export * from "./SummaryCards.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCards.vue?vue&type=style&index=0&id=0b8d6eb2&scoped=true&lang=css&"
import style1 from "./SummaryCards.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d6eb2",
  null
  
)

export default component.exports